export default "__VITE_ASSET__b99b6ec9__"